  import jsPDF from "jspdf";
  import "jspdf-autotable";
  import { toWords } from "number-to-words";
  
  
  export const generateInvoicePdfNew = (invoiceData) => {
      const doc = new jsPDF();
  
      const margin = 8;
      const pageWidth = doc.internal.pageSize.width;
      const centerX = pageWidth / 2;
  
      const formatDate = (inputDate) => {
        if (!inputDate) return "N/A";
        const [year, month, day] = inputDate.split("-"); // YYYY-MM-DD
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${day}-${monthNames[parseInt(month) - 1]}-${year}`;
      };
  
      const formattedDate = formatDate(invoiceData?.date);
  
      // Header
      doc.setFont("helvetica", "bold").setFontSize(14);
      doc.text("Hare Krishna Traders".toUpperCase(), centerX, 13, { align: "center" });
  
      const addressLines = [
        "12/22, Koothanur, Mallikundam Road, Mecheri, Salem 636458",
        "Phone: 9787292119, 9789573268, 9790168814 | Email: jayaprakash892@gmail.com",
        "GSTIN: 33CFYPM6838M1ZF | State: TamilNadu (33)"
      ];
  
      let addressY = 20;
      addressLines.forEach(line => {
        doc.setFont("helvetica", "normal").setFontSize(8);
        doc.text(line, centerX, addressY, { align: "center" });
        addressY += 5;
      });
  
      doc.setDrawColor(150);
      doc.line(margin, addressY + 1, pageWidth - margin, addressY + 1);
      doc.setFontSize(12).setTextColor(0, 0, 128).setFont("helvetica", "bold");
      doc.text("TAX INVOICE", centerX, addressY + 5, { align: "center" });
  
      // Invoice info
      doc.setFontSize(9).setTextColor(0, 102, 51);
      doc.text("Invoice Details:", 130, addressY + 10);
      doc.setFontSize(8).setTextColor(0);
      doc.text(`Invoice No: ${invoiceData?.invoiceNo || "N/A"}`, 130, addressY + 15);
      doc.text(`Date: ${formattedDate}`, 130, addressY + 20);
      doc.text(`Place of Supply: TamilNadu (33)`, 130, addressY + 25);
  
      // Bill To
      doc.setFontSize(9).setTextColor(0, 102, 51);
      doc.text("Bill To:", margin, addressY + 10);
  
      let billToY = addressY + 15;
      doc.setFont("helvetica", "bold").setFontSize(9);
      doc.text(invoiceData?.shopName?.toUpperCase() || "N/A", margin, billToY);
      billToY += 5;
  
      doc.setFont("helvetica", "normal").setFontSize(8);
  
      const billingLines = (invoiceData?.billingAddress || "N/A").split('\n');
      billingLines.forEach(line => {
        doc.text(line, margin, billToY);
        billToY += 4;
      });
  
      doc.text(`Contact No: ${invoiceData?.shopContactNo || "N/A"}`, margin, billToY);
      billToY += 4;
      doc.text(`GSTIN Number: ${invoiceData?.shopGst || "N/A"}`, margin, billToY);
      billToY += 4;
      doc.text(`State: TamilNadu (33)`, margin, billToY);
  
  
      // Flatten items from nested updateQuantityInvoiceItem
      const items = invoiceData?.updateQuantityInvoiceItem?.flatMap(sheet =>
        sheet.items.map(item => ({ ...item, sheetName: sheet.sheetName }))
      ) || [];
  
      const totals = items.reduce((acc, item) => {
        const qty = item.quantity ?? 0;
        const discount = item.discount ?? 0;
        const price = parseFloat(item.mrpPerPcs ?? 0);
        const gst = parseFloat((item.gst) ?? 0);
        acc.totalQuantity += qty;
        acc.totalAmount += (qty * price) * (1 - (discount / 100));
        acc.price += (qty * (price * (1 - (discount / 100))) * 100) / (100 + gst);
        acc.totalGST += ((qty * price) * (1 - (discount / 100))) - ((qty * (price * (1 - (discount / 100))) * 100) / (100 + gst));
        return acc;
      }, { totalQuantity: 0, totalGST: 0, price: 0, totalAmount: 0 });
  
      const productCount = items.length;
      const dynamicCellPadding = productCount > 25 ? 1 : 1.5;
      const fontsizeadjust = productCount > 25 ? 7 : 8;
  
      // Main Item Table
      doc.autoTable({
        head: [["S.NO", "Product Name", "MRP", "Qty", "Unit", "Price/Unit", "GST/Unit", "Discount", "Price", "GST Amt", "Total"]],
        body: [
          ...items.map((item, index) => {
            const qty = item.quantity ?? 0;
            const mrp = item.mrp;
            const unit = item.unit;
            const discount = item.discount ?? 0;
            const unitPrice = item.mrpPerPcs ?? 0;
            const gst = item.gst ?? 0;
            const discountedPrice = unitPrice * (1 - (discount / 100));
            const unitGst = discountedPrice - (((discountedPrice) * 100) / (100 + gst));
            const noGstPrice = ((discountedPrice) * 100) / (100 + gst);
            const price = qty * ((discountedPrice) * 100) / (100 + gst);
            const total = qty * discountedPrice;
            const gstAmt = (qty * discountedPrice) - (qty * ((discountedPrice) * 100) / (100 + gst));
  
            return [
              index + 1,
              item.productName || "-",
              mrp, // MRP not in input 
              qty,
              unit, // default unit
              noGstPrice.toFixed(2),
              (unitGst).toFixed(2),
              discount, // discount placeholder
              price.toFixed(2),
              gstAmt.toFixed(2),
              total.toFixed(2)
            ];
          }),
          [
            { content: "TOTAL", styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
            "",
            "",
            totals.totalQuantity,
            "",
            "",
            "",
            "",
            totals.price.toFixed(2),
            totals.totalGST.toFixed(2),
            totals.totalAmount.toFixed(2)
          ]
        ],
        startY: billToY + 6,
        theme: "grid",
        styles: {
          fontSize: fontsizeadjust,
          cellPadding: dynamicCellPadding,
          fontStyle: "bold",
          tableLineColor: [0, 0, 0],
          tableLineWidth: 1
        },
        headStyles: {
          fillColor: [0, 102, 51],
          textColor: [255, 255, 255],
        },
        margin: 8,
        pageBreak: "auto"
      });
  
      let finalY = doc.lastAutoTable.finalY + 0;
  
      const summaryData = [
        ["Subtotal Price", totals.price.toFixed(2)],
        ["SGST @9%", (totals.totalGST / 2).toFixed(2)],
        ["CGST @9%", (totals.totalGST / 2).toFixed(2)],
        ["Rounded Off Total", Math.round(totals.totalAmount).toFixed(2)],
        [
          { content: "TOTAL", styles: { fontStyle: "bold", fillColor: [255, 204, 0], halign: "center" } },
          { content: totals.totalAmount.toFixed(2), styles: { fontStyle: "bold", fillColor: [255, 204, 0], halign: "right" } }
        ]
      ];
  
      doc.autoTable({
        startY: finalY,
        head: [["Description", "Amount[Rs]"]],
        body: summaryData,
        theme: "grid",
        styles: {
          fontSize: fontsizeadjust,
          cellPadding: dynamicCellPadding,
          textColor: [0, 0, 0],
          fontStyle: "bold"
        },
        headStyles: {
          fillColor: [0, 102, 51],
          textColor: [255, 255, 255],
        },
        columnStyles: {
          0: { cellWidth: 30, halign: "left" },
          1: { cellWidth: 25, halign: "right" },
        },
        margin: { left: 147 },
        tableWidth: 35,
      });
  
      let totalAmountWords = toWords(Math.round(totals.totalAmount)).toLowerCase() + " only";
      doc.setFontSize(9).setTextColor(0, 0, 0);
      doc.text("Invoice Amount In Words:", margin, doc.lastAutoTable.finalY - 28);
      doc.setFontSize(9).setTextColor(0, 102, 51);
      doc.text(totalAmountWords, margin, doc.lastAutoTable.finalY - 22);
      doc.setFontSize(9).setTextColor(0, 0, 0);
      doc.text("Terms and Conditions", margin, doc.lastAutoTable.finalY - 16);
      doc.setFontSize(9).setTextColor(127, 0, 255);
      doc.text("Thanks for doing business with us", margin, doc.lastAutoTable.finalY - 8);
  
      if (invoiceData?.shippingAddress) {
        doc.setFontSize(10).setTextColor(0, 102, 51);
        doc.text("Shipping Address", margin, doc.lastAutoTable.finalY - 0);
        doc.setFontSize(9).setTextColor(0, 0, 0);
        doc.text(invoiceData.shippingAddress, margin, doc.lastAutoTable.finalY + 8);
      }
  
      let footerY = doc.lastAutoTable.finalY + 8;
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("For: HARE KRISHNA TRADERS", 150, footerY);
  
      doc.setFont("helvetica", "bold").text("Authorized Signatory", pageWidth - 15, footerY + 20, { align: "right" });
      doc.setLineWidth(0.5).line(pageWidth - 60, footerY + 13, pageWidth - 13, footerY + 13);
  
      doc.save(`Invoice_${invoiceData.invoiceNo || "N/A"}.pdf`);
    };